import { useQuery } from "react-query";
import axios from "infra/http";
import { PaginateResult } from "core/resources/types/shared";
import { ContaItemResponse, ContaFiltroType } from "../typings";

function useContas(params: Partial<ContaFiltroType> & { enabled?: boolean }) {
  const parseValuesParams = Object.values(params)
    .map((value) => `${value}`)
    .join("-");

  const _enabled = params.enabled ?? true;

  delete params.enabled;

  return useQuery(
    `/v1/conta-${parseValuesParams}`,
    async () => {
      const { data } = await axios.get<PaginateResult<ContaItemResponse>>(
        `/v1/conta`,
        {
          params: {
            ...params,
            pago:
              params.pago === true
                ? "1"
                : params.pago === false
                ? "0"
                : undefined,
            atraso:
              params.atraso === true
                ? "1"
                : params.atraso === false
                ? "0"
                : undefined,
          },
        }
      );

      return data;
    },
    {
      enabled: !!params.operacao && _enabled,
    }
  );
}

export default useContas;
